export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return
  }

  const authStore = resolveAuthStore()
  if (!authStore) {
    return
  }

  await authStore.checkAuth()

  if (!authStore.isAuthenticated) {
    return navigateTo('/auth/login')
  }

  if (!authStore.isAdmin) {
    return navigateTo('/dashboard')
  }
}) 